/**
 * @generated SignedSource<<b1c722cf34517adc7cd6ff66498df259>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloudStorageProvider = "GOOGLE_DRIVE" | "ONEDRIVE" | "%future added value";
export type UploadClientAssetVersionInput = {
  projectId: string;
  assetId: string;
  storageKey?: string | null;
  fileName?: string | null;
  sizeBytes?: number | null;
  cloudLink?: ClientAssetCloudLinkInput | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ClientAssetCloudLinkInput = {
  provider: CloudStorageProvider;
  externalFileId: string;
};
export type clientAssetMutationsUploadVersionMutation$variables = {
  input: UploadClientAssetVersionInput;
};
export type clientAssetMutationsUploadVersionMutation$data = {
  readonly uploadClientAssetVersion: {
    readonly asset: {
      readonly id: string;
      readonly status: string;
    } | null;
  } | null;
};
export type clientAssetMutationsUploadVersionMutation = {
  variables: clientAssetMutationsUploadVersionMutation$variables;
  response: clientAssetMutationsUploadVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadClientAssetVersionPayload",
    "kind": "LinkedField",
    "name": "uploadClientAssetVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientAsset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientAssetMutationsUploadVersionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientAssetMutationsUploadVersionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6faba1e7369c9c6350e362461908d7bf",
    "id": null,
    "metadata": {},
    "name": "clientAssetMutationsUploadVersionMutation",
    "operationKind": "mutation",
    "text": "mutation clientAssetMutationsUploadVersionMutation(\n  $input: UploadClientAssetVersionInput!\n) {\n  uploadClientAssetVersion(input: $input) {\n    asset {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac92402207a7576b28adbfb09d488a4e";

export default node;
